import { useSessao } from '../lib/sessao'
import { Topo } from '../componentes/ui'
import { SecaoGrade, SecaoJornadas } from './ConfigSecoes'

/**
 * Que horas a clínica trabalha.
 *
 * Duas coisas diferentes que só fazem sentido juntas:
 *
 *  · a **grade** é a régua — de quantos em quantos minutos a agenda
 *    desenha uma linha;
 *  · a **jornada** é o expediente — de que hora a que hora cada
 *    profissional (ou a clínica inteira) atende.
 *
 * `public.jornada` aceita `dono_tipo = 'CLINICA'` desde a 0006, então o
 * horário de funcionamento do estabelecimento mora aqui e não numa
 * coluna nova da identidade — duas fontes para a mesma pergunta é como
 * a agenda passa a discordar de si mesma.
 *
 * Sem jornada nenhuma, a grade aceita marcação às três da manhã. É por
 * isso que este é um passo da montagem, e não um ajuste fino.
 */
export function Horarios() {
  const { pode } = useSessao()
  const podeEditar = pode('config:write')
  return (
    <>
      <Topo titulo="Horários"
            subtitulo="O expediente e a régua da agenda. Sem jornada definida, a grade aceita marcação em qualquer hora — inclusive de madrugada.">
        {!podeEditar && <span className="selo selo--neutro">só leitura</span>}
      </Topo>
      <SecaoJornadas podeEditar={podeEditar} />
      <SecaoGrade podeEditar={podeEditar} />
    </>
  )
}
